import React, { useEffect, useState } from "react";
import {
    useNavigate,
  Link,
  useLocation
} from "react-router-dom";
import "../styles/Payments.css";

/* ─── Icons ─── */
const LayoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
  </svg>
);
const RepeatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const HelpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const DownloadIcon = ({ size = 15, color = "#2563EB" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);
const CheckCircleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const ChevronLeft = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

/* ─── Data ─── */
const NAV_ITEMS = [
  { label: "Dashboard", icon: <LayoutIcon />, active: false,path: "/dashboard" },
  { label: "Conversions", icon: <RepeatIcon />, active: false,path: "/conversions" },
  { label: "Payments", icon: <CreditCardIcon />, active: true,path: "/payments" },
  { label: "Settings", icon: <SettingsIcon />, active: false,path: "/settings" },
  { label: "Help", icon: <HelpIcon />, active: false,path: "/help" },
];

/* ─── Sidebar ─── */
function Sidebar({subscription}) {
    const location = useLocation();
    const navigate = useNavigate();
    const currentUser = JSON.parse(
      localStorage.getItem("currentUser") || "{}"
    );


    const handleLogout = () => {
              localStorage.removeItem("currentUser");
              localStorage.removeItem("selectedPlan");
              navigate("/");
            };

  return (
    <aside className="pm-sidebar">
      <div className="pm-sidebar-upper">
        <div className="pm-profile">
          <div className="pm-avatar">
            {currentUser.full_name
              ? currentUser.full_name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")
                  .substring(0, 2)
                  .toUpperCase()
              : "U"}
          </div>
          <div className="pm-profile-info">
            <span className="pm-profile-name">
              {currentUser.full_name || "User"}
            </span>
            <span className="pm-profile-role">
              {currentUser.email || ""}
            </span>
          </div>
        </div>
        <nav className="pm-nav">
          {NAV_ITEMS.map((item) => (
                                  <Link
                                    key={item.label}
                                    to={item.path}
                                    className={`pm-nav-item ${
                                      location.pathname === item.path
                                        ? "pm-nav-item--active"
                                        : ""
                                    }`}
                                  >
                                    <span className="pm-nav-icon">
                                      {item.icon}
                                    </span>

                                    {item.label}
                                  </Link>
                                ))}
                            {/* ─── Logout separator + button ─── */}
                                                                    <div className="db-nav-separator" />
                                                                    <button className="db-nav-item db-nav-logout" onClick={handleLogout}>
                                                                      <span className="db-nav-icon">
                                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E24646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                                          <polyline points="16 17 21 12 16 7" />
                                                                          <line x1="21" y1="12" x2="9" y2="12" />
                                                                        </svg>
                                                                      </span>
                                                                      Log Out
                                                                    </button>
        </nav>
      </div>
      <div className="pm-plan-badge">
        <div className="pm-plan-badge-header">
          <span className="pm-plan-tier">
            {subscription?.plan_name?.toUpperCase() || "FREE"}
          </span>
          <span className="pm-plan-dot" />
        </div>
        <span className="pm-plan-name">
          {subscription?.status || "No Plan"}
        </span>
        <span className="pm-plan-renew">Auto-renews {
                                          subscription?.end_date
                                            ? new Date(
                                                subscription.end_date
                                              ).toLocaleDateString()
                                            : "-"
                                        }</span>
      </div>
    </aside>
  );
}

/* ─── Main Content ─── */
function MainContent({
  subscription,
  setSubscription,
}) {
    //const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paymentMethods, setPaymentMethods] = useState([]);

  const totalSpent = payments.reduce(
    (sum, payment) => sum + Number(payment.amount || 0),
    0
  );

    const defaultMethod =
      paymentMethods.find(
        m => m.is_default
      );

    const billingAddress =
      defaultMethod?.billing_address;

  const statCards = [
    {
      label: "MONTHLY SPEND",
      value: `₹${subscription?.amount || 0}`,
      sub: "Current billing cycle",
      color: "#2563EB",
    },
    {
      label: "TOTAL SPENT",
      value: `₹${totalSpent}`,
      sub: "Lifetime account spending",
      color: "#10B981",
    },
    {
      label: "NEXT PAYMENT",
      value: subscription?.end_date
        ? new Date(subscription.end_date).toLocaleDateString()
        : "-",
      sub: "Auto renewal scheduled",
      color: "#2563EB",
    },
  ];

  const currentUser = JSON.parse(
    localStorage.getItem("currentUser")
  );

  const userId = currentUser?.user_id;

  useEffect(() => {
    const loadData = async () => {
      try {
        if (!userId) return;

        const paymentMethodRes = await fetch(
          `${API_URL}/payment-methods/${userId}`
        );

        const paymentMethodData =
          await paymentMethodRes.json();

        setPaymentMethods(paymentMethodData);

        const subscriptionRes = await fetch(
          `${API_URL}/subscription/${userId}`
        );

        const paymentsRes = await fetch(
          `${API_URL}/payments/${userId}`
        );

        const subscriptionData =
          await subscriptionRes.json();

        const paymentsData =
          await paymentsRes.json();

        setSubscription(subscriptionData);
        setPayments(paymentsData);

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [userId, API_URL,setSubscription]);

    if (loading) {
      return (
        <div>
          Loading payments...
        </div>
      );
    }

  return (
    <main className="pm-main">
      {/* Page Header */}
      <div className="pm-page-header">
        <div>
          <h1 className="pm-page-title">Payments & Billing</h1>
          <p className="pm-page-sub">Manage your subscription, invoices, and payment methods</p>
        </div>
        <div className="pm-header-actions">
          <button className="pm-btn-outline">
            <DownloadIcon size={14} color="#475569" />
            Download All Invoices
          </button>
          <Link
            to="/upgradeplans"
            className="pm-btn-primary"
          >
            Upgrade Plan
          </Link>
        </div>
      </div>

      {/* Stat Cards */}
      <div className="pm-stats-row">
        {statCards.map((card) => (
          <div key={card.label} className="pm-stat-card">
            <div className="pm-stat-header">
              <span className="pm-stat-label">{card.label}</span>
              <div className="pm-stat-icon" style={{ background: card.color }} />
            </div>
            <div className="pm-stat-body">
              <span className="pm-stat-value">{card.value}</span>
              <span className="pm-stat-sub">{card.sub}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Two-Column Grid */}
      <div className="pm-two-col">
        {/* Payment Method */}
        <div className="pm-card">
          <div className="pm-card-header">
            <h4>Payment Method</h4>
            <p>Manage your active payment choices and billing defaults</p>
          </div>
          <div className="pm-divider" />
          <div className="pm-card-display">

            {paymentMethods.length > 0 ? (

              paymentMethods.map((method) => (

                <div
                  key={method.payment_method_id}
                  className="pm-visa-row"
                >

                  <div className="pm-visa-info">

                    {method.payment_type === "CARD" ? (
                      <>
                        <span className="pm-visa-logo">
                          {method.card_brand}
                        </span>

                        <div>
                          <span className="pm-visa-number">
                            {method.card_brand} ending in {method.card_last4}
                          </span>

                          <span className="pm-visa-expiry">
                            Expires {method.expiry_month}/{method.expiry_year}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <span className="pm-visa-logo">
                          UPI
                        </span>

                        <div>
                          <span className="pm-visa-number">
                            {method.upi_id}
                          </span>
                        </div>
                      </>
                    )}

                  </div>

                  {method.is_default && (
                    <span className="pm-default-badge">
                      Default
                    </span>
                  )}

                </div>

              ))

            ) : (

              <div className="pm-empty">
                No payment methods found
              </div>

            )}

          </div>
          <div className="pm-billing-address">
            <span className="pm-label">BILLING ADDRESS</span>
            <span className="pm-address">
              {billingAddress ? (
                <>
                  {billingAddress.street_address}, {" "}
                  {billingAddress.city}, {" "}
                  {billingAddress.state_region} {" "}
                  {billingAddress.postal_code}
                </>
              ) : (
                "No billing address found"
              )}
            </span>
          </div>
          <div className="pm-card-actions">
            <Link
              to="/updatepaymentmethod"
              state={{
                paymentMethod:
                  paymentMethods.find(
                    m => m.is_default
                  )
              }}
              className="pm-btn-primary"
            >
              Update Card
            </Link>
            <Link
                to="/addpaymentmethod"
                className="pm-btn-primary"
            >
                Add New Method
            </Link>
          </div>
        </div>

        {/* Current Plan */}
        <div className="pm-card">
          <div className="pm-card-header">
            <h4>Current Plan</h4>
            <p>Review your current subscription benefits and limits</p>
          </div>
          <div className="pm-divider" />
          <div className="pm-plan-info">
            <div>
              <span className="pm-plan-title-lg">
                {subscription
                  ? `Plan ${subscription.plan_id}`
                  : "No Active Plan"}
              </span>
              <span className="pm-plan-desc">Individual professional allocation</span>
            </div>
            <span className="pm-status-active">
              {subscription?.status || "Inactive"}
            </span>
          </div>
          <div className="pm-plan-price">
            <span className="pm-price">
              ₹{subscription?.amount || 0}
            </span>
            <span className="pm-price-period">/ month</span>
          </div>
          <div className="pm-features">
            {subscription?.features?.map((feature) => (
              <div key={feature} className="pm-feature-row">
                <CheckCircleIcon />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Invoice History */}
      <div className="pm-card">
        <div className="pm-card-header">
          <h4>Invoice History</h4>
          <p>View recent enterprise invoices and statement activities</p>
        </div>
        <div className="pm-table">
          <div className="pm-table-head">
            <span>INVOICE</span><span>DATE</span><span>DESCRIPTION</span>
            <span>AMOUNT</span><span>STATUS</span><span></span>
          </div>
          {payments.length === 0 && (
            <div className="pm-empty">
              No invoices available yet.
            </div>
          )}
          {payments.map((payment) => (
            <div
              key={payment.payment_id}
              className="pm-table-row"
            >
              <span className="pm-invoice-id">
                {payment.transaction_id}
              </span>

              <span className="pm-invoice-date">
                {payment.paid_at}
              </span>

              <span className="pm-invoice-desc">
                {payment.provider}
              </span>

              <span className="pm-invoice-amount">
                ₹{payment.amount}
              </span>

              <span className="pm-invoice-status">
                {payment.status}
              </span>
              <button className="pm-download-btn"><DownloadIcon size={14} /></button>
            </div>
          ))}
        </div>
        <div className="pm-pagination">
          <span className="pm-page-info">
            {payments.length > 0
              ? `Showing 1-${payments.length} of ${payments.length} invoices`
              : "No invoices found"}
          </span>
          <div className="pm-page-controls">
            <button className="pm-page-btn" disabled><ChevronLeft /> Previous</button>
            <button className="pm-page-btn">Next <ChevronRight /></button>
          </div>
        </div>
      </div>
    </main>
  );
}

/* ─── Payments Page ─── */
export default function ConvertProPayments() {
  const [subscription, setSubscription] = useState(null);

  return (
    <div className="pm-layout">
      <Sidebar subscription={subscription} />
      <MainContent
        subscription={subscription}
        setSubscription={setSubscription}
      />
    </div>
  );
}

